import { ApiPartialDate } from "@/types/common.types.ts";
import { ApiFieldTypes } from "@/types/custom-field.types.ts";
import { ApiApplicantSavePayload } from "@/types/recruit/applicant.types.ts";

export type ApplicantSystemData = Pick<
  ApiApplicantSavePayload,
  | "first_name"
  | "last_name"
  | "middle_name"
  | "location"
  | "contacts"
  | "current_position"
  | "salary"
  | "birth_date"
>;

export const applicantSystemFieldTypes = [
  ApiFieldTypes.applicant_first_name,
  ApiFieldTypes.applicant_last_name,
  ApiFieldTypes.applicant_middle_name,
  ApiFieldTypes.applicant_location,
  ApiFieldTypes.applicant_phone,
  ApiFieldTypes.applicant_email,
  ApiFieldTypes.applicant_telegram,
  ApiFieldTypes.applicant_position,
  ApiFieldTypes.applicant_company,
  ApiFieldTypes.applicant_salary,
  ApiFieldTypes.applicant_date_birth,
];

export const getApplicantSystemValue = (
  type: ApiFieldTypes,
  applicant: ApplicantSystemData
): string | ApiPartialDate | null | undefined => {
  switch (type) {
    case ApiFieldTypes.applicant_first_name:
      return applicant.first_name;
    case ApiFieldTypes.applicant_last_name:
      return applicant.last_name;
    case ApiFieldTypes.applicant_middle_name:
      return applicant.middle_name;
    case ApiFieldTypes.applicant_location:
      return applicant.location;
    case ApiFieldTypes.applicant_phone:
      return applicant.contacts.phone;
    case ApiFieldTypes.applicant_email:
      return applicant.contacts.email;
    case ApiFieldTypes.applicant_telegram:
      return applicant.contacts.telegram_username;
    case ApiFieldTypes.applicant_position:
      return applicant.current_position.position;
    case ApiFieldTypes.applicant_company:
      return applicant.current_position.company;
    case ApiFieldTypes.applicant_salary:
      return applicant.salary;
    case ApiFieldTypes.applicant_date_birth:
      return applicant.birth_date;
    default:
      return undefined;
  }
};
